import { Construction } from "lucide-react";
import { EmptyState, PageHeader } from "@/components/design";
import { StatusBadge } from "@/components/design/status-badge";

interface PlaceholderPageProps {
  title: string;
  description: string;
  status?: "Draft" | "Submitted";
}

export function PlaceholderPage({
  title,
  description,
  status = "Draft",
}: PlaceholderPageProps) {
  return (
    <div className="space-y-6">
      <PageHeader
        title={title}
        description={description}
        badge={<StatusBadge status={status} />}
      />
      <EmptyState
        icon={Construction}
        title="Module in progress"
        description="Routing, layout, and API foundation are ready. Business logic ships in the next sprint."
      />
    </div>
  );
}
